/**
 * Utilitário de log centralizado para a aplicação
 * Substitui os console.log/error/warn para fornecer um padrão consistente
 */
export const logger = {
  /**
   * Registra uma mensagem informativa
   * @param message - Mensagem principal
   * @param optionalParams - Parâmetros adicionais para o log
   */
  info: (message: string, ...optionalParams: any[]) => {
    console.log(`[INFO] ${message}`, ...optionalParams);
  },

  /**
   * Registra uma mensagem de erro
   * @param message - Mensagem de erro
   * @param optionalParams - Parâmetros adicionais para o log
   */
  error: (message: string, ...optionalParams: any[]) => {
    console.error(`[ERRO] ${message}`, ...optionalParams);
  },

  /**
   * Registra uma mensagem de aviso
   * @param message - Mensagem de aviso
   * @param optionalParams - Parâmetros adicionais para o log
   */
  warn: (message: string, ...optionalParams: any[]) => {
    console.warn(`[AVISO] ${message}`, ...optionalParams);
  },

  /**
   * Registra uma mensagem de depuração
   * @param message - Mensagem de depuração
   * @param optionalParams - Parâmetros adicionais para o log
   */
  debug: (message: string, ...optionalParams: any[]) => {
    if (process.env.NODE_ENV !== 'production') {
      console.debug(`[DEBUG] ${message}`, ...optionalParams);
    }
  }
};
